import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

type tProps = {
  message: string;
  confirmText?: string;
  rejectText?: string;
  extraActionText?: string;
  onConfirm: tVoidFn;
  onReject: tVoidFn;
  onExtraAction?: tVoidFn;
};
const ConfirmToast = (props: tProps) => {
  const { t, ready } = useTranslation(["common"]);
  if (!ready) return null;
  return (
    <div>
      <div
        style={{
          marginBottom: "10px",
        }}
      >
        {props.message}
      </div>
      <div>
        <button
          style={{ marginRight: "20px", color: "var(--color-cta)" }}
          onClick={props.onConfirm}
        >
          {props.confirmText || t("common:yes")}
        </button>
        <button style={{ marginRight: "20px" }} onClick={props.onReject}>
          {props.rejectText || t("common:no")}
        </button>
        {props.extraActionText && props.onExtraAction && (
          <button
            style={{ color: "var(--color-danger)" }}
            onClick={props.onExtraAction}
          >
            {props.extraActionText}
          </button>
        )}
      </div>
    </div>
  );
};

type tShowConfirmToastArgs = {
  componentProps: tProps;
  toastArgs: {
    onClose?: tVoidFn;
  };
};
export const showConfirmToast = ({
  componentProps,
  toastArgs,
}: tShowConfirmToastArgs) => {
  return toast(<ConfirmToast {...componentProps} />, {
    draggable: false,
    position: "bottom-left",
    hideProgressBar: false,
    onClose: toastArgs.onClose,
    pauseOnHover: true,
    closeOnClick: false,
    autoClose: 5000,
  });
};

export default ConfirmToast;
